import { render, staticRenderFns } from "./viewPayslip.vue?vue&type=template&id=37558ca4&scoped=true"
import script from "./viewPayslip.vue?vue&type=script&lang=js"
export * from "./viewPayslip.vue?vue&type=script&lang=js"
import style0 from "./viewPayslip.vue?vue&type=style&index=0&id=37558ca4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37558ca4",
  null
  
)

export default component.exports